module.exports = __webpack_public_path__ + "static/media/TotalNigeriaLogo.28aada61.svg";